export const TEC_RELATIONSHIP_TYPES = [
  { label: "EXATEC", value: "EXATEC" },
  { label: "Colaborador", value: "Colaborador", legacyValues: ["COLABORATOR"] },
  { label: "Profesor", value: "Profesor", legacyValues: ["PROFESSOR"] },
  { label: "Alumno", value: "Alumno", legacyValues: ["STUDENT"] }
];
